import { render, staticRenderFns } from "./SideBarPanel.vue?vue&type=template&id=5bdbc544&scoped=true&"
import script from "./SideBarPanel.vue?vue&type=script&lang=js&"
export * from "./SideBarPanel.vue?vue&type=script&lang=js&"
import style0 from "./SideBarPanel.vue?vue&type=style&index=0&id=5bdbc544&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bdbc544",
  null
  
)

export default component.exports